<div *ngIf="!loading" class="font-roboto-700 mb-4 max-sm:mb-2 max-sm:text-11">
  <div class="flex items-center">
    <a
      class="flex items-center gap-2 max-sm:gap-1 cursor-pointer hover:underline"
      [routerLink]="[openDashboard()]"
    >
      <img
        alt="sportLogo"
        class="w-[25px] h-[25px] object-contain max-sm:w-[19px] max-sm:h-[19px]"
        [src]="breadcrumb.sportLogo"
      />
      <div>{{ breadcrumb.sport | translate }}</div>
    </a>

    <div class="mx-2" *ngIf="breadcrumb.competition">
      <img alt="right-pointer" [src]="urlIcon + 'right-pointer.svg'" />
    </div>

    <div *ngIf="breadcrumb.competition">
      <div
        class="flex items-center gap-2 max-sm:gap-1 cursor-pointer hover:underline"
        *ngIf="!isCompetition"
      >
        <img
          alt="competitionLogo"
          class="w-[25px] h-[25px] rounded-full object-contain"
          [src]="breadcrumb.competitionLogo"
          *ngIf="breadcrumb.competitionLogo != ''"
        />
        <div>
          {{ transform(breadcrumb.competition, 40) }}
        </div>
      </div>
      <a
        class="flex items-center gap-2 max-sm:gap-1 cursor-pointer hover:underline"
        *ngIf="isCompetition"
        [routerLink]="[openCompetition()]"
      >
        <img
          alt="competitionLogo"
          class="w-[25px] h-[25px] object-contain"
          [src]="breadcrumb.competitionLogo"
          *ngIf="breadcrumb.competitionLogo != ''"
        />
        <div>
          {{ transform(breadcrumb.competition, 40) }}
        </div>
      </a>
    </div>
  </div>
</div>
